import React, { useEffect, useState } from 'react';
import { getPublishedLaborBudgetVersions, importPublishedLaborBudget } from '../../utils/laborBudgetApi';

export default function LaborBudgetImport({ orgId, locationId, year, onImported }) {
  const [versions, setVersions] = useState([]);
  const [versionId, setVersionId] = useState('');
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (!open) return;
    let active = true;
    setBusy(true);
    getPublishedLaborBudgetVersions({ orgId, locationId, year })
      .then(rows => { if (active) { setVersions(rows); setVersionId(rows[0]?.id || ''); } })
      .catch(e => { if (active) setMessage(e.response?.data?.error || e.message); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, [open, orgId, locationId, year]);
  return <div className="mb-4 text-sm">
    <button className="text-orange-700" disabled={busy} onClick={() => { setOpen(!open); setMessage(''); }}>Import a published budget</button>
    {open && <div className="border border-gray-200 rounded p-3 mt-2 flex flex-wrap items-center gap-3">
      <label>Published budget<select className="border rounded ml-2 p-2" value={versionId} disabled={busy} onChange={e => setVersionId(e.target.value)}>
        {!versions.length && <option value="">No published budgets for {year}</option>}
        {versions.map(v => <option value={v.id} key={v.id}>{v.name || `Budget ${v.year}`}</option>)}
      </select></label>
      <span className="text-gray-500">Replaces monthly budgets for the positions in this budget, including manual edits.</span>
      <button className="bg-orange-500 text-white rounded px-3 py-2 disabled:opacity-40" disabled={busy || !versionId} onClick={async () => {
        setBusy(true); setMessage('');
        try { const result = await importPublishedLaborBudget({ orgId, locationId, versionId: Number(versionId) }); setMessage(`Imported ${result.positionsSynced} positions for ${year}.`); onImported(); }
        catch (e) { setMessage(e.response?.data?.error || e.message); }
        finally { setBusy(false); }
      }}>{busy ? 'Loading…' : 'Import monthly budgets'}</button>
    </div>}
    {message && <p role="status" className="mt-2">{message}</p>}
  </div>;
}
